import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../api/client';

type PaymentMethod = {
  id: string;
  brand: string;
  last4: string;
  expMonth: number;
  expYear: number;
};

export function usePaymentMethod() {
  const {
    getToken,
    isLoaded,
    isSignedIn,
    orgId: clerkOrganizationId,
  } = useAuth();

  return useQuery<PaymentMethod | null>({
    queryKey: ['payment-method', clerkOrganizationId],
    enabled: isLoaded && isSignedIn === true && !!clerkOrganizationId,
    queryFn: async () => {
      const token = await getToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const { data, error, response } = await apiClient.GET(
        '/api/v1/billing/payment-method',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 404) {
        return null;
      }

      if (error || !response.ok || !data) {
        throw new Error('Failed to fetch payment method');
      }

      return data.paymentMethod as PaymentMethod;
    },
    retry: false,
  });
}
